export default __webpack_public_path__ + "static/media/utp-class.8c41ed00.svg";